import {
  BankIcon,
  File02Icon,
  WorkIcon
} from "@hugeicons-pro/core-solid-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { VerifyMethodType } from "shared/types";
import { getVerificationCategory } from "views/applications-id-report/slices/CombinedIncomeReportSlice/utils";
import { InstitutionLogo } from "views/applications-id-report/slices/IncomeReportSlice/components/InstitutionLogo";

const categoryIcon = {
  [VerifyMethodType.Bank]: BankIcon,
  [VerifyMethodType.Payroll]: WorkIcon,
  [VerifyMethodType.Documents]: File02Icon
};

export const Logo = ({
  logo,
  verified_source_type
}: {
  logo?: string;
  verified_source_type?: string;
}) => {
  if (logo) return <InstitutionLogo logo={logo} />;

  if (!verified_source_type) return null;

  const category = getVerificationCategory(verified_source_type);
  // Bank/payroll keep their own glyph; every document-based method (paystub,
  // bank statement, w2, benefits, offer letter) resolves to the documents glyph.
  const icon = categoryIcon[category] || File02Icon;

  return (
    <div className="p-2 rounded-md bg-primary-500 h-10 w-10 ">
      <HugeiconsIcon icon={icon} className="w-6 h-6 text-white" />
    </div>
  );
};
